import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=ecde0e28&scoped=true&"
import script from "./companyInfo.vue?vue&type=script&lang=js&"
export * from "./companyInfo.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./companyInfo.vue?vue&type=style&index=0&id=ecde0e28&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ecde0e28",
  "83866d34"
  
)

export default component.exports